const countryCodes = [
  // all countries
  /*"AFG",
  "EGY",
  "ALA",
  "ALB",
  "DZA",
  "ASM",
  "AND",
  "AGO",
  "AIA",
  "ATA",
  "ATG",
  "GNQ",
  "ARG",
  "ARM",
  "ABW",
  "AZE",
  "ETH",
  "AUS",
  "BHS",
  "BHR",
  "BGD",
  "BRB",
  "BLR",
  "BEL",
  "BLZ",
  "BEN",
  "BMU",
  "BTN",
  "BOL",
  "BES",
  "BIH",
  "BWA",
  "BVT",
  "BRA",
  "IOT",
  "BRN",
  "BGR",
  "BFA",
  "BDI",
  "CHL",
  "CHN",
  "COK",
  "CRI",
  "CUW",
  "DNK",
  "COD",
  "DEU",
  "DMA",
  "DOM",
  "DJI",
  "ECU",
  "SLV",
  "CIV",
  "ERI",
  "EST",
  "SWZ",
  "FLK",
  "FRO",
  "FJI",
  "FIN",
  "FRA",
  "GUF",
  "PYF",
  "ATF",
  "GAB",
  "GMB",
  "GEO",
  "GHA",
  "GIB",
  "GRD",
  "GRC",
  "GRL",
  "GLP",
  "GUM",
  "GTM",
  "GGY",
  "GIN",
  "GNB",
  "GUY",
  "HTI",
  "HMD",
  "HND",
  "HKG",
  "IND",
  "IDN",
  "IMN",
  "IRQ",
  "IRN",
  "IRL",
  "ISL",
  "ISR",
  "ITA",
  "JAM",
  "JPN",
  "YEM",
  "JEY",
  "JOR",
  "VGB",
  "VIR",
  "CYM",
  "KHM",
  "CMR",
  "CAN",
  "CPV",
  "KAZ",
  "QAT",
  "KEN",
  "KGZ",
  "KIR",
  "CCK",
  "COL",
  "COM",
  "XKX",
  "HRV",
  "CUB",
  "KWT",
  "LAO",
  "LSO",
  "LVA",
  "LBN",
  "LBR",
  "LBY",
  "LIE",
  "LTU",
  "LUX",
  "MAC",
  "MDG",
  "MWI",
  "MYS",
  "MDV",
  "MLI",
  "MLT",
  "MAR",
  "MHL",
  "MTQ",
  "MRT",
  "MUS",
  "MYT",
  "MEX",
  "FSM",
  "MDA",
  "MCO",
  "MNG",
  "MNE",
  "MSR",
  "MOZ",
  "MMR",
  "NAM",
  "NRU",
  "NPL",
  "NCL",
  "NZL",
  "NIC",
  "NLD",
  "NER",
  "NGA",
  "NIU",
  "PRK",
  "MNP",
  "MKD",
  "NFK",
  "NOR",
  "OMN",
  "AUT",
  "TLS",
  "PAK",
  "PSE",
  "PLW",
  "PAN",
  "PNG",
  "PRY",
  "PER",
  "PHL",
  "PCN",
  "POL",
  "PRT",
  "PRI",
  "COG",
  "REU",
  "RWA",
  "ROU",
  "RUS",
  "MAF",
  "SLB",
  "ZMB",
  "WSM",
  "SMR",
  "BLM",
  "STP",
  "SAU",
  "SWE",
  "CHE",
  "SEN",
  "SRB",
  "SYC",
  "SLE",
  "ZWE",
  "SGP",
  "SXM",
  "SVK",
  "SVN",
  "SOM",
  "ESP",
  "LKA",
  "SHN",
  "KNA",
  "LCA",
  "SPM",
  "VCT",
  "ZAF",
  "SDN",
  "SGS",
  "KOR",
  "SSD",
  "SUR",
  "SJM",
  "SYR",
  "TJK",
  "TWN",
  "TZA",
  "THA",
  "TGO",
  "TKL",
  "TON",
  "TTO",
  "TCD",
  "CZE",
  "TUN",
  "TUR",
  "TKM",
  "TCA",
  "TUV",
  "UGA",
  "UKR",
  "HUN",
  "URY",
  "UZB",
  "VUT",
  "VAT",
  "VEN",
  "ARE",
  "USA",
  "GBR",
  "VNM",
  "WLF",
  "CXR",
  "ESH",
  "CAF",
  "CYP"*/
  
  //EU Countries & USA
  "AUT",
  "BEL",
  "BGR",
  "HRV",
  "CYP",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "IRL",
  "ITA",
  "LVA",
  "LTU",
  "LUX",
  "MLT",
  "NLD",
  "POL",
  "PRT",
  "ROU",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "GBR",
  "LIE",
  "USA"
]

export default countryCodes